import { Edit, useForm } from "@refinedev/antd";
import { useList } from "@refinedev/core";
import { HttpError } from "@refinedev/core";
import { Form, Input, Select } from "antd";
import { useEffect } from "react";

export function PlanEdit() {
  const { formProps, saveButtonProps, query, formLoading } = useForm<any, HttpError, any>({
    resource: "subscription-plan",
    successNotification: (data) => {
      return {
        message: data?.data.message,
        type: "success",
      };
    },
    action: "edit",
  });

  const plan = query?.data?.data?.data;

  const { data: categoriesData } = useList({
    resource: "category",
    filters: [{ field: "status", operator: "eq", value: "ACTIVE" }],
    pagination: { pageSize: 100 },
  });
  const categories = categoriesData?.data || [];

  useEffect(() => {
    if (plan && formProps.form) {
      formProps.form.setFieldsValue({
        title: plan.name,
        description: plan.description,
        productType: plan.productType,
        categoryIDs: plan.categories?.map((c: { categoryID: string }) => c.categoryID) ?? [],
        secondaryCta: plan.secondaryCta ?? "",
        secondaryCtaLabel: plan.secondaryCtaLabel ?? "",
      });
    }
  }, [plan, formProps.form]);

  return (
    <Edit
      saveButtonProps={saveButtonProps}
      isLoading={formLoading}
      resource="plan"
      mutationMode="optimistic"
      title="Edit Plan"
    >
      <Form {...formProps} layout="vertical">
        <Form.Item label="Title" name={["title"]} rules={[{ required: true }]}>
          <Input />
        </Form.Item>
        <Form.Item label="Description" name={["description"]} rules={[{ required: true }]}>
          <Input.TextArea />
        </Form.Item>
        <Form.Item label="Product Type" name={["productType"]} rules={[{ required: true }]}>
          <Select
            placeholder="Select product type"
            options={[
              { value: "COACH", label: "Coach" },
              { value: "GYM", label: "Gym" },
              { value: "CLUB", label: "Club" },
            ]}
          />
        </Form.Item>
        <Form.Item label="Categories" name={["categoryIDs"]}>
          <Select
            mode="multiple"
            placeholder="Select categories"
            showSearch
            optionFilterProp="label"
            options={(categories as Array<{ id: string; title: string }>).map((cat) => ({
              value: cat.id,
              label: cat.title,
            }))}
          />
        </Form.Item>
        <Form.Item
          label="Secondary CTA URL"
          name={["secondaryCta"]}
          rules={[{
            validator: (_, value) => {
              if (!value) return Promise.resolve();
              return /^https?:\/\/.+/.test(value) ? Promise.resolve() : Promise.reject("Please enter a valid URL");
            },
          }]}
        >
          <Input placeholder="https://example.com" />
        </Form.Item>
        <Form.Item
          label="Secondary CTA Label"
          name={["secondaryCtaLabel"]}
          rules={[{ max: 200, message: "Max 200 characters" }]}
        >
          <Input placeholder="e.g. Learn More" maxLength={200} />
        </Form.Item>
      </Form>
    </Edit>
  );
}